import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { DeleteParticipantEmbeddableForm } from '../mutations/deleteParticipantEmbeddableForm.mutation';
import type {
  DeleteParticipantEmbeddableFormMutation,
  DeleteParticipantEmbeddableFormMutationVariables,
} from '../types';

export const useDeleteParticipantEmbeddableFormMutation = (
  options?: MutationOptions<
    DeleteParticipantEmbeddableFormMutation,
    DeleteParticipantEmbeddableFormMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantEmbeddableForm), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
